import { AppAction } from '../actions/appAction';
import { CallAudioUpload, CallAudioUploadState } from '../state/callAudioUploadState';
import produce from 'immer';

const unloaded: CallAudioUploadState = {
	uploads: [],
	failures: [],
	currentUploadOrder: 0
};

export function callAudioUploadReducer(state: CallAudioUploadState | undefined = unloaded, action: AppAction): CallAudioUploadState {
	switch (action.type) {
		case 'call-audio-upload/queue-uploads':
			return produce(state, draft => {
				// making sure everything uses the same date - this may or
				// may not help sorting in certain cases
				const now = new Date();
				
				draft.uploads = [
					...draft.uploads,
					...action.uploads.map<CallAudioUpload>(f => ({ ...f, status: 'queued', uploadOrder: ++draft.currentUploadOrder, uploadedTime: new Date(now) }))
				];
				
				draft.failures = draft.failures.filter(f => !action.failureIdsToClear.some(id => f.uploadId === id));
				
				draft.failures = [
					...action.failuresToAdd.map(f => ({ ...f, uploadOrder: ++draft.currentUploadOrder, uploadedTime: new Date(now) })),
					...draft.failures
				];
			});
		case 'call-audio-upload/upload-started':
			return produce(state, draft => {
				const upload = draft.uploads.find(u => u.uploadId === action.uploadId);
				if (upload) {
					upload.status = 'uploading';
				}
			});
		case 'call-audio-upload/upload-finishing':
			return produce(state, draft => {
				const upload = draft.uploads.find(u => u.uploadId === action.uploadId);
				if (upload) {
					upload.status = 'finishing';
				}
			});
		case 'call-audio-upload/upload-succeeded':
			return produce(state, draft => {
				draft.uploads = draft.uploads.filter(u => u.uploadId !== action.uploadId);
			});
		case 'call-audio-upload/upload-failed':
			return produce(state, draft => {
				const upload = draft.uploads.find(u => u.uploadId === action.uploadId);
				if (!upload)
					return;
				
				draft.uploads = draft.uploads.filter(u => u.uploadId !== action.uploadId);
				draft.failures.unshift({
					uploadId: upload.uploadId,
					callIdentifier: upload.callIdentifier,
					jobId: upload.jobId,
					filename: upload.filename,
					description: action.description,
					failureType: action.failureType,
					uploadOrder: upload.uploadOrder,
					uploadedTime: upload.uploadedTime
				});
			});
		default:
			return state;
	}
}